import { Form, TimePicker } from 'antd';
import React from 'react';

import { IFieldBase } from '../../interfaces';
import { ItemTaskType } from '../../types';

const FieldStartTime: React.FC<IFieldBase> = ({ disabled }) => {
    return (
        <Form.Item<ItemTaskType>
            label="Start Time"
            name="start_datetime"
            rules={[{ required: true, message: 'Please input date!' }]}
        >
            <TimePicker minuteStep={10} style={{ width: '100%' }} format={'h:mm A'} disabled={disabled} />
        </Form.Item>
    );
};

export default React.memo(FieldStartTime);
